import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-content" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
            <img 
              src="/assets/icon-closeup.jpg" 
              alt="Pixovia Logo" 
              style={{ 
                width: window.innerWidth <= 768 ? '32px' : '40px', 
                height: window.innerWidth <= 768 ? '32px' : '40px', 
                borderRadius: '8px',
                objectFit: 'cover'
              }} 
            />
            <div style={{ fontSize: window.innerWidth <= 768 ? '1.5rem' : '2rem', fontWeight: 'bold', color: '#00d4ff' }}>Pixovia Store</div>
          </Link>
        </div>
        {/* Mobile Menu Button */}
        {window.innerWidth <= 768 && (
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: '#00d4ff',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        )}
        
        <nav style={{
          display: window.innerWidth <= 768 ? (mobileMenuOpen ? 'block' : 'none') : 'block',
          position: window.innerWidth <= 768 ? 'absolute' : 'static',
          top: window.innerWidth <= 768 ? '100%' : 'auto',
          left: window.innerWidth <= 768 ? '0' : 'auto',
          right: window.innerWidth <= 768 ? '0' : 'auto',
          background: window.innerWidth <= 768 ? '#1a1a2e' : 'transparent',
          border: window.innerWidth <= 768 ? '1px solid rgba(255,255,255,0.1)' : 'none',
          borderRadius: window.innerWidth <= 768 ? '0 0 10px 10px' : '0',
          zIndex: 1000
        }}>
          <ul className="nav-links" style={{
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
            padding: window.innerWidth <= 768 ? '1rem' : '0',
            margin: window.innerWidth <= 768 ? '0' : 'auto',
            gap: window.innerWidth <= 768 ? '0.5rem' : '2rem'
          }}>
            <li><Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link></li>
            <li><Link to="/apps" onClick={() => setMobileMenuOpen(false)}>Apps</Link></li>
            <li><Link to="/games" onClick={() => setMobileMenuOpen(false)}>Games</Link></li>
            <li><Link to="/themes" onClick={() => setMobileMenuOpen(false)}>Themes</Link></li>
            <li><Link to="/extensions" onClick={() => setMobileMenuOpen(false)}>Extensions</Link></li>
            <li><Link to="/upload" onClick={() => setMobileMenuOpen(false)}>Upload App</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;